import { render } from "./SelectionTextToolbar.vue?vue&type=template&id=3cc1c2fe&scoped=true"
import script from "./SelectionTextToolbar.vue?vue&type=script&lang=js"
export * from "./SelectionTextToolbar.vue?vue&type=script&lang=js"

import "./SelectionTextToolbar.vue?vue&type=style&index=0&id=3cc1c2fe&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc1c2fe"]])

export default __exports__